export enum CustomElementsEnum {
  downloadProfileCV = 'app-download-profile-cv-content'
}
